module.exports = __webpack_public_path__ + "static/media/create_group_student.90220220.csv";